module.exports = __webpack_public_path__ + "img/pick2.f82fd42b.jpg";